<div fxLayout="column" fxLayoutGap="12px">
  <section fxLayout fxLayoutGap="10px">
    <sbnb-icon-airbnb *ngIf="!login" fxFlex="0 0 26px" fxHide.lt-md [size]="26"></sbnb-icon-airbnb>
    <h2 class="nomargin" style="line-height: 1.5">
      <span *ngIf="!login">Connecting {{ 'CORE.PRODUCT_NAME' | transloco }} with Airbnb</span>
      <span *ngIf="login">Upgrade your Airbnb account</span>
    </h2>
  </section>

  <section *ngIf="!login">
    <p>We're an official Airbnb software partner, so connecting takes minutes.</p>
    <p>
      Deliver a better guest experience and save time responding to common guest questions, publishing guest reviews,
      and more, with our automated, AI-powered tools.
    </p>
    <p>
      Before you click Continue, make sure you are logged in to Airbnb with the account you want to connect to
      Hospitable.com.
    </p>
  </section>

  <section *ngIf="login">
    <p class="nomargin">
      For over a year, Airbnb's engineering team and ours have been working together to create a unique integration that
      serves your needs better. A few final checks before we get started upgrading your account:
    </p>
    <ul>
      <li>
        <strong>Are you a co-host?</strong>
        You'll need to invite your listing owners to connect to Hospitable.com after you’ve completed the upgrade.
        <a
          target="_blank"
          href="https://help.hospitable.com/en/articles/5538758-how-to-connect-an-airbnb-account-official-integration"
          class="raspberry-darker">
          Find out more here
        </a>
      </li>

      <li>
        <strong>Do you have multiple Airbnb accounts?</strong>
        Make sure that you are logged in as
        <em>{{ login }}</em>
        on
        <a class="raspberry-darker" target="_blank" href="https://www.airbnb.com/login?has_logged_out=1">airbnb.com</a>
        before you start the upgrade.
      </li>

      <li>
        <strong>How long will the upgrade take?</strong>
        Give us 30 minutes, max 🙏. You'll still be able to use our application during the upgrade, and we'll continue
        to send messages. A few conversations may be missing during this time. Rest assured they are there and we're
        working for you in the background.
      </li>
    </ul>

    <p>
      Still have questions? Check out our
      <a
        class="raspberry-darker"
        target="_blank"
        href="https://help.hospitable.com/en/articles/5538758-how-to-connect-an-airbnb-account-official-integration">
        Airbnb upgrade article
      </a>
      , or
      <a class="raspberry-darker clickable" (click)="contactSupport()">reach out to our friendly support team</a>
      .
    </p>
  </section>

  <section>
    <div
      fxLayout
      fxLayoutGap="18px"
      fxLayoutAlign="end center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center stretch">
      <button
        id="connect-permissions-cancel"
        mat-flat-button
        [disabled]="loading"
        fxFlexOrder.lt-md="99"
        class="button__secondary"
        [routerLink]="['/accounts']"
        *ngIf="!login">
        Cancel
      </button>
      <button id="connect-permissions-primary" mat-flat-button [disabled]="loading" (click)="phaseComplete.emit()">
        {{ login ? 'Upgrade now' : 'Connect' }}
        <mat-spinner class="button__spinner" *ngIf="loading" diameter="30"></mat-spinner>
      </button>
    </div>
  </section>
</div>
